export default __webpack_public_path__ + "static/media/3121.2f67becd.jpg";